export default __webpack_public_path__ + "static/media/Side_Tracking.e2c232e2.gif";